<template>
  <div>
    <PageHeader :gradientType="gradientType" />
    <PageContent>
      <template #filterBar>
        <form @submit.prevent="setFilter">
          <h6 class="heading-small text-muted mb-4">Search</h6>
          <div class="row">
            <div class="col">
              <a-input
                placeholder="Search by"
                v-model="table.filters.sub_domain"
              >
                <a-select
                  slot="addonAfter"
                  default-value="sub_domain"
                  style="width: 120px"
                >
                  <a-select-option value="sub_domain">
                    Sub Domain
                  </a-select-option>
                </a-select>
              </a-input>
            </div>
          </div>
          <hr />
          <h6 class="heading-small text-muted mb-4">Filter by Status</h6>
          <div class="row">
            <div class="col">
              <a-radio-group
                v-model="table.filters.site_status"
                :default-value="null"
                @change="setFilter"
              >
                <a-radio :style="radio.style" :value="null">
                  All
                </a-radio>
                <a-radio :style="radio.style" value="A">
                  Active
                </a-radio>
                <a-radio :style="radio.style" value="I">
                  Inactive
                </a-radio>
                <a-radio :style="radio.style" value="X">
                  Deactivated
                </a-radio>
              </a-radio-group>
            </div>
          </div>
        </form>
      </template>

      <template #pageTable>
        <PageTable
          :tableTitle="table.title"
          :apiUrl="table.apiUrl"
          :tableFields="table.fields"
          :appendedParams="table.filters"
          :sortOrder="table.sortOrder"
        >
          <template #headerButtons>
            <base-button
              id="new"
              class="float-right ml-1"
              type="primary"
              size="sm"
              v-if="selectedActions.includes('Add')"
              @click="openDrawer()"
              >+ Add Site Page</base-button
            >
          </template>

          <template #formDrawer>
            <a-drawer
              :width="drawer.width"
              :placement="drawer.placement"
              :visible="drawer.visible"
              @close="closeDrawer"
            >
              <SitePageForm
                :viewMode="viewMode"
                :sitePageData="sitePageData"
                :drawerVisible="drawer.visible"
                @closeDrawer="closeDrawer"
              />
            </a-drawer>
          </template>

          <template #tableButtons="{tableProps}">
            <button
              id="view"
              class="btn btn-success btn-sm"
              v-if="selectedActions.includes('View')"
              @click.prevent="openDrawer(tableProps.rowData)"
            >
              View
            </button>
            <button
              id="edit"
              class="btn btn-warning btn-sm"
              v-if="selectedActions.includes('Edit')"
              @click.prevent="openDrawer(tableProps.rowData)"
            >
              Edit
            </button>
            <a-popconfirm
              title="You are about to delete this record?"
              v-if="selectedActions.includes('Delete')"
              @confirm="deleteRow(tableProps.rowData)"
              okText="Delete"
              cancelText="Cancel"
            >
              <a class="btn btn-danger btn-sm text-white">Delete</a>
            </a-popconfirm>
          </template>
        </PageTable>
      </template>
    </PageContent>
  </div>
</template>

<script>
import PageHeader from '../../components/Page/Header.vue';
import PageContent from '../../components/Page/Content.vue';
import PageTable from '../../components/Page/Table.vue';
import SitePageForm from './SitePageForm.vue';
import HTTPRequest from '../../controllers/httpRequest';
import { mapGetters } from 'vuex';

export default {
  components: {
    PageHeader,
    PageContent,
    PageTable,
    SitePageForm
  },
  data() {
    return {
      // selectedActions: [],
      gradientType: 'gradient-yellow',
      sitePageData: null,
      drawer: {
        visible: false,
        width: 0,
        placement: 'right'
      },
      viewMode: false,
      table: {
        title: 'Site Pages',
        apiUrl: '/api/v1/clp_site_pages',
        fields: [
          'actions',
          { name: 'membershipProgram.name', title: 'Membership Program' },
          { name: 'sub_domain', title: 'Sub Domain Name' },
          { name: 'site_title', title: 'Site Title' },
          {
            name: 'site_status',
            title: 'Site Status',
            formatter(value) {
              if (value === 'A') return 'Active';
              else if (value === 'I') return 'Inactive';
              else if (value === 'X') return 'Deactivated';
              else return '';
            }
          }
        ],
        sortOrder: [
          {
            field: 'id',
            direction: 'desc'
          }
        ],
        filters: {
          site_status: null,
          sub_domain: null
        }
      },

      radio: {
        style: {
          display: 'block',
          height: '35px',
          lineHeight: '30px'
        }
      }
    };
  },
  computed: {
    ...mapGetters({
      selectedActions: 'getModuleSelectedActions'
    })
  },
  methods: {
    openDrawer(rowData = null) {
      this.viewMode = event.target.id == 'view' ? true : false;
      this.sitePageData = rowData;
      this.drawer.visible = true;
    },

    closeDrawer() {
      this.drawer.visible = false;
      this.sitePageData = null;
    },

    setFilter() {
      this.$root.$emit('refreshTable');
    },

    getWindowWidth() {
      this.drawer.width = window.innerWidth;
    },

    async deleteRow(rowData) {
      const sitePageId = rowData.id;

      const response = await HTTPRequest.deleteRequest(
        `/api/v1/clp_site_pages/${sitePageId}`,
        {
          site_page: {
            membership_program_id: rowData.membership_program_id
          }
        }
      );

      if (response.message == 'Success') {
        this.$notification.success({
          message: 'Success'
        });
        this.$root.$emit('refreshTable');
      } else {
        if (response.error != undefined) {
          this.$notification.error({
            message: response.error
          });
        } else {
          this.$notification.error({
            message: 'Something went wrong. Please try again.'
          });
        }
      }
    }
  },

  created() {
    this.getWindowWidth();
    this.$store.dispatch('setCurrentModule', 'SitePage');
  },

  mounted() {
    this.selectedActions = this.$store.getters.getModuleSelectedActions;
  }
};
</script>

<style scoped></style>
